<template>
  <v-autocomplete
    v-model="HISTOGRAMA_SELECIONADOS"
    :items="itens"
    item-text="text"
    item-value="value"
    label="Histograma"
    outlined
    multiple
    hide-details
    clearable
  >
    <template #prepend-item>
      <SysItemListaSelecionaTudo
        v-model="HISTOGRAMA_SELECIONADOS"
        :itens="itens"
        valor-chave="value"
      />
      <v-divider />
    </template>

    <template #selection="{item}">
      <TextoOutrosFiltrosSelecionadosAutocomplete
        :filtros="HISTOGRAMA_SELECIONADOS"
        :item="item"
        item_key="value"
        item_value="text"
        retornar_texto_completo
      />
    </template>
  </v-autocomplete>
</template>

<script>
import SysItemListaSelecionaTudo from "@/components/utils/crud/SysItemListaSelecionaTudo.vue";
import TextoOutrosFiltrosSelecionadosAutocomplete
  from "@/components/Diagnostico/utils/TextoOutrosFiltrosSelecionadosAutocomplete.vue";

export default {
  components: {TextoOutrosFiltrosSelecionadosAutocomplete, SysItemListaSelecionaTudo},
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: ["modelValue"],
  computed: {
    HISTOGRAMA_SELECIONADOS: {
      get() { return this.modelValue; },
      set(valor) { this.$emit("update:modelValue", valor) }
    }
  },
  data: () => ({
    itens: [
      { text: '0. Sem histórico de vendas', value: '0. Sem histórico de vendas' },
      { text: '1. Até 1 mês sem vender', value: '1. Até 1 mês sem vender' },
      { text: '2. De 1 a 2 meses sem vender', value: '2. De 1 a 2 meses sem vender' },
      { text: '3. De 2 a 3 meses sem vender', value: '3. De 2 a 3 meses sem vender' },
      { text: '4. De 3 a 6 meses sem vender', value: '4. De 3 a 6 meses sem vender' },
      { text: '5. De 6 a 9 meses sem vender', value: '5. De 6 a 9 meses sem vender' },
      { text: '6. De 9 a 12 meses sem vender', value: '6. De 9 a 12 meses sem vender' },
      { text: '7. Acima de 12 meses sem vender', value: '7. Acima de 12 meses sem vender' },
    ]
  })
}
</script>

<style>

</style>
